import type { ReactElement, ReactNode } from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';
import { Component as CloseIcon } from 'icons/icon-ui--close.svg';

type CloseBtnProps = {
  onClick: () => void;
  className?: string;
};

function CloseBtn({ onClick, className }: CloseBtnProps): ReactElement {
  return (
    <button
      className={`close ${className}`}
      type="button"
      aria-label="Close modal"
      style={{ padding: 0, border: 0 }}
      onClick={onClick}
    >
      <CloseIcon width="32" height="32" />
    </button>
  );
}

type Props = {
  show: boolean;
  header?: ReactNode;
  body: ReactNode;
  footer?: ReactNode;
  className?: string;
  wrapperClassName?: string;
  closeBtnClassName?: string;
  onClose?: () => void;
};

function Modal({
  show,
  header,
  body,
  footer,
  className = '',
  wrapperClassName = '',
  closeBtnClassName = '',
  onClose = () => null,
}: Props): ReactElement {
  return (
    <BootstrapModal
      show={show}
      dialogClassName={className}
      className={wrapperClassName}
      animation={false}
      onHide={onClose}
      keyboard
    >
      {header && (
        <BootstrapModal.Header>
          {header}
          <CloseBtn className={closeBtnClassName} onClick={onClose} />
        </BootstrapModal.Header>
      )}

      <BootstrapModal.Body>
        {body}
      </BootstrapModal.Body>

      {footer && (
        <BootstrapModal.Footer>
          {footer}
        </BootstrapModal.Footer>
      )}
    </BootstrapModal>
  );
}

type HeaderProps = {
  className?: string,
  center?: boolean,
  children?: React.ReactNode,
};

function Header({
  className = 'c-heading--brand-4',
  center = true,
  children,
}: HeaderProps) {
  return (
    <div
      className={[
        'modal-title',
        center ? 'modal-title--center' : '',
      ].join(' ')}
    >
      <h5 className={`c-heading ${className}`}>
        {children}
      </h5>
    </div>
  );
}

Modal.Header = Header;
Modal.CloseBtn = CloseBtn;

export default Modal;
